<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">أضافة اعلان جديدة</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="addNewBanner">
              <div class="card-body__form">
                <div class="row">
                  <!-- Banner Type -->
                  <div class="col-12">
                    <div class="form-group">
                      <label for="banner_type">نوع الاعلان</label>
                      <select
                        class="form-control form-select"
                        aria-label="Default select"
                        id="banner_type"
                        v-model="banner.banner_type"
                      >
                        <option disabled :value="0">اختار نوع الاعلان</option>
                        <option :value="1">نص</option>
                        <option :value="2">صورة</option>
                        <option :value="3">نص وصورة</option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- Text Only -->
                <Transition name="scale" mode="out-in">
                  <div class="row" v-if="banner.banner_type == 1">
                    <div class="col-12">
                      <!-- Banner Title -->
                      <div class="form-group">
                        <label for="bannerTitle">العنوان</label>
                        <textarea
                          class="form-control"
                          id="bannerTitle"
                          placeholder="العنوان"
                          required
                          v-model="banner.title"
                          rows="3"
                          cols="5"
                          maxlength="70"
                        ></textarea>
                      </div>
                      <!-- Description -->
                      <div class="form-group">
                        <label for="title">وصف</label>
                        <textarea
                          class="form-control"
                          placeholder="وصف"
                          id="title"
                          cols="30"
                          required
                          maxlength="150"
                          v-model="banner.description"
                          rows="6"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </Transition>
                <!-- Image Only -->
                <Transition name="scale" mode="out-in">
                  <div class="row" v-if="banner.banner_type == 2">
                    <div class="col-12">
                      <div class="from-group">
                        <label for="">صورة الاعلان</label>
                        <UploadImages
                          class="form-control"
                          @changed="handleImages"
                          :max="1"
                          maxError="يمكنك رفع صورة واحدة لكل اعلان"
                          fileError="لا يمكن رفع ملفات غير الصور"
                        />
                      </div>
                    </div>
                  </div>
                </Transition>
                <!-- Text and Image -->
                <Transition name="scale" mode="out-in">
                  <div class="row" v-if="banner.banner_type == 3">
                    <!-- Banner Data -->
                    <div class="col-lg-8">
                      <!-- Banner Title -->
                      <div class="form-group">
                        <label for="bannerTitle">العنوان</label>
                        <textarea
                          class="form-control"
                          id="bannerTitle"
                          placeholder="العنوان"
                          required
                          v-model="banner.title"
                          rows="3"
                          cols="5"
                          maxlength="200"
                        ></textarea>
                      </div>
                      <!-- Description -->
                      <div class="form-group">
                        <label for="title">وصف</label>
                        <textarea
                          class="form-control"
                          placeholder="وصف"
                          id="title"
                          cols="30"
                          required
                          maxlength="250"
                          v-model="banner.description"
                          rows="6"
                        ></textarea>
                      </div>
                    </div>
                    <!-- Banner Image -->
                    <div class="col-lg-4">
                      <div class="from-group">
                        <label for="">صورة الاعلان</label>
                        <UploadImages
                          class="form-control"
                          @changed="handleImages"
                          :max="1"
                          maxError="يمكنك رفع صورة واحدة لكل اعلان"
                          fileError="لا يمكن رفع ملفات غير الصور"
                        />
                      </div>
                    </div>
                  </div>
                </Transition>
              </div>
              <div class="card-footer">
                <button
                  :disabled="banner.banner_type == 0"
                  type="submit"
                  class="btn btn-primary"
                >
                  حفظ
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex Store
import { mapActions } from "vuex";
// Upload Image
import UploadImages from "vue-upload-drop-images";

import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();

export default {
  data() {
    return {
      thumbnail: null,
      file: null,
      banner: {
        title: "",
        image_url: "",
        description: "",
        banner_type: 0,
        content_dynamic_link: null,
      },
    };
  },
  components: {
    UploadImages,
  },
  methods: {
    ...mapActions("bannersModule", ["addBanner"]),

    // Add New Banner
    async addNewBanner() {
      if (this.file !== null) {
        const content = {
          component: FirebaseUploadingFileVue,
          props: {
            title: "يتم رفع صورة الاعلان الان",
            file: this.file,
            collection: "IMAGEs",
            contentType: this.file.type,
            onFinished: (url) => {
              console.log(url);
              this.banner.image_url = url ?? "";
              toast.dismiss(toastId);
              this.addBanner(this.banner);
              this.clearAndShowSuccess();
              this.$router.go(-1);
            },
          },
        };
        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        this.addBanner(this.banner);
        this.clearAndShowSuccess();
        this.$router.go(-1);
      }
    },
    //-----------------------------------------------------//
    // Add thumbnail Banner
    handleImages(files) {
      this.file = files[0];
    },
    //-----------------------------------------------------//
    // clear Data when close modal
    clearData() {
      this.file = null;
      this.banner = {
        title: "",
        image_url: "",
        description: "",
        banner_type: 1,
        content_dynamic_link: null,
      };
    },
    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم إضافة الاعلان بنجاح",
      });
    },
    // All Two functions
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
    //---------------------//
  },
};
</script>